import { Users, CheckCircle2, Info } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { userRoles } from "../../App";
import "../../assets/styles/ActivityCard2.css";

export default function ActivityCard({
  _id,
  activityName,
  posterImage,
  capacity,
  participantsCount,
  type,
  flags,
  role,
}) {
  const navigate = useNavigate();

  const percent = capacity
    ? Math.min(100, Math.round((participantsCount / capacity) * 100))
    : 0;

  const renderJoinButton = () => {
    return (
      <button
        className={`btn btn-sm w-100 ${
          flags.canJoin ? "btn-primary" : "btn-light"
        }`}
        disabled={!flags.canJoin}
      >
        {flags.joinStatus === "joined" && (
          <>
            <CheckCircle2 size={16} className="me-1 text-success" />
            {flags.joinMessage}
          </>
        )}

        {flags.joinStatus !== "joined" && flags.joinMessage}
      </button>
    );
  };

  return (
    <div className="activity-card">
      <div className="activity-img-wrapper">
        <img
          src={posterImage ? posterImage : "/Errors/cancelled.png"}
          alt={activityName}
          className="activity-img"
        />

        {/* 🏷 Badge نوع النشاط */}
        <span className="activity-type-badge">{type}</span>
      </div>

      <div className="activity-body">
        <h5 className="activity-title">{activityName}</h5>

        {capacity && participantsCount && (
          <div className="activity-count">
            <Users size={16} />
            <span>
              {participantsCount} / {capacity}
            </span>
          </div>
        )}

        {/*  Progress */}
        <div className="progress activity-progress">
          <div className="progress-bar" style={{ width: `${percent}%` }} />
        </div>

        <div className="activity-actions">
          <button
            className="btn btn-outline-primary btn-sm w-100"
            onClick={() => navigate(`/activities/categories/${_id}`)}
          >
            <Info size={16} className="me-1" />
            View Details
          </button>

          {/*  زرار التسجيل حسب الحالة */}
          {renderJoinButton()}

          {/*  Supervisor */}
          {role === userRoles.supervisor && flags.isSupervisor && (
            <div className="btn btn-light border text-primary btn-sm w-100">
              You are supervisor
            </div>
          )}

          {/*  Admin */}
          {role === userRoles.admin && (
            <div className="d-flex gap-2">
              <button
                className={`btn btn-sm w-100 ${
                  flags.joinStatus === "closed"
                    ? "btn-secondary" // التسجيل مغلق
                    : flags.joinStatus === "ended"
                      ? "btn-dark" // النشاط انتهى
                      : "btn-outline-success" // افتراضي لو النشاط مفتوح
                }`}
                onClick={() => navigate(`/activities/categories/${_id}`)}
              >
                Manage
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
